import { PU_SendMsg } from "./plug/base";
const { PU_CheckVerionOK } = require("@/utils/plug/base");

export const WindowsMsgType_ShowDoaloadView = 2;

export const WindowsMsgType_ShowPopView = 3; //显示弹出框
export const WindowsMsgType_GetInjectData = 4; //获取当前页面的Inject数据，需要回调
export const WindowsMsgType_ShowAlert = 5; //显示alert弹出框
export const WindowsMsgType_ShowConfirm = 6; //显示confrim

export const WindowsMsgType_AddJsOrCss = 9; //加载css文件或者js文件

export const WindowsMsgType_SendChatMsg = 10; //发送聊天文字

const WindowsMsgType_RequestInjectData = 11; //达人的请求数据，可以避开msToken

// export function MsgUtil_PostEval(a){
//     window.top.postMessage({from:"zzb_web",content:a,messageType:1}, "*");
// }

export function MsgUtil_RequestInjectData(data) {
  window.top.postMessage({ from: "zzb_web", data, messageType: WindowsMsgType_RequestInjectData }, "*");
}

export function MsgUtil_PostCss(className, key, value, content) {
  window.top.postMessage({ from: "zzb_web", content, data: { className, key, value }, messageType: 1 }, "*");
}
//添加html数据到父页面
//checkHasElementClassName 检查是否多次添加的className，前面不需要加.
//addType 添加的类型 ，0 append，1 prepend，2 before，3 after
//parentElementName 添加时候的父元素，可以是#xx，也可以是.xxx,用在$(parentElementName)
//content 添加的内容
export function MsgUtil_AddHtml(checkHasElementClassName, addType, parentElementName, content) {
  window.top.postMessage(
    {
      from: "zzb_web",
      content,
      data: { checkHasElementClassName, addType, content, parentElementName },
      messageType: 8,
    },
    "*"
  );
}

export async function ZzbWeb_ShowPop(path, viewId, title, postData, params) {
  var t = new Date().getTime();
  var isPass = await PU_CheckVerionOK(7); // 检查版本
  var url2 = isPass ? "https://tool.zzbtool.com" : `https://tool.3977s.com`;
  var url = `${url2}/index.html?t=${t}#${path}`;
  if (!postData) postData = {};
  if (!params) params = {};
  if (params.showUrl) {
    url = params.showUrl + `?t=${t}#${path}`;
    url2 = params.showUrl;
  }
  postData["from"] = "zzb";
  if (!params.viewX) params.viewX = "1300px";
  if (!params.viewY) params.viewY = "650px";
  ZzbWebOpenView(title, params, postData, url, url2, viewId);
}
//显示弹出框
function ZzbWebOpenView(title, params, postData, url, url2, viewId) {
  console.log(title, params, postData, url, url2, viewId);
  //在插件里要加入插件ID，当前url，插件版本，是否同意等
  var data = { title, params, postData, url, url2, viewId };
  MsgUtil_PostData(data, WindowsMsgType_ShowPopView);
}

export function ZzbWebConfirm(content, jumpUrl) {
  //在插件里要加入插件ID，当前url，插件版本，是否同意等
  var data = { content, jumpUrl };
  MsgUtil_PostData(data, WindowsMsgType_ShowConfirm);
}

export function ZzbWebAddJsOrCss(jsUrls, cssUrls) {
  var data = { jsUrls, cssUrls };
  // var data = {from:"zzb_web",data:{jsUrls,cssUrls},messageType:WindowsMsgType_AddJsOrCss}
  // data = {cmd:"zzb_web",data}
  // // MsgUtil_PostData(data,WindowsMsgType_AddJsOrCss)
  // PU_SendMsg({data})
  ZzbWebSendMsgToPlug(data, WindowsMsgType_AddJsOrCss);
}
export function ZzbWebSendChatMsg(message) {
  var data = { content: message };
  ZzbWebSendMsgToPlug(data, WindowsMsgType_SendChatMsg);
}
function ZzbWebSendMsgToPlug(data, messageType) {
  var data2 = { from: "zzb_web", data: data, messageType };
  data2 = { cmd: "zzb_web", data: data2 };
  PU_SendMsg({ data: data2 });
}

export function ZzbWebAlert(title, content, jumpUrl) {
  //在插件里要加入插件ID，当前url，插件版本，是否同意等
  var data = { title, content, jumpUrl };
  MsgUtil_PostData(data, WindowsMsgType_ShowAlert);
}

export function MsgUtil_PostData(data, messageType) {
  if (!messageType) messageType = 1;
  window.top.postMessage({ from: "zzb_web", data, messageType }, "*");
}
export function MsgUtil_PostJs(reloadUrl) {
  window.parent.postMessage({ cmd: "reloadUrl", from: "zzbweb", url: reloadUrl }, "*");
}

//工具箱发送指令给插件
//msgType  峰哥那边给   9：是占位符 /01是淘宝 01指的是每个功能模块的内容
export function ToolSendPlug(content = "", data = null, msgType) {
  //在插件里要加入插件ID，当前url，插件版本，是否同意等
  // console.log(content,data,msgType)
  debugger;
  window.top.postMessage({ from: "zzb_web", content, data, messageType: msgType }, "*");
  // window.top.postMessage({from:"zzb_web",content,data:{className,key,value},messageType:1}, "*");
}
